module.exports = __webpack_public_path__ + "resources/img/img_security_dfinder_fds_en.0127a51f0ebe2fb5f6851ea03ad2e0a7.png";